import { ClientActionTypes } from './constants';

const INIT_STATE = {
    clientId: sessionStorage.getItem('selectedClientId') || null,
    clientName: sessionStorage.getItem('selectedClientName') || null,
};

const Client = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ClientActionTypes.SET_CLIENT_ID:
            if (action.payload) {
                sessionStorage.setItem('selectedClientId', action.payload);
            } else {
                sessionStorage.removeItem('selectedClientId');
            }
            return {
                ...state,
                clientId: action.payload,
            };
        case ClientActionTypes.SET_CLIENT_NAME:
            if (action.payload) {
                sessionStorage.setItem('selectedClientName', action.payload);
            } else {
                sessionStorage.removeItem('selectedClientName');
            }
            return {
                ...state,
                clientName: action.payload,
            };
        default:
            return state;
    }
};

export default Client;
